import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _MessageTemplate, _PaymentMethod } from "../../../core/services/dataBean/EntityCatalogVdos";
import { SelectTypeProcees } from "../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { MyEditor } from "../../theme/Component/MyEditor";



export const MessageTemplateBpm = () => {

    const MessageTemplate = useDataBean(_MessageTemplate);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        MessageTemplate.instance.getMessageTemplateCatalogPorPropiedad('State', 1, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }




    const create = () => {
        MessageTemplate.setBean({
            State: 1
        });
        setModal({ ...modal, "view": true });
    }

    const eliminarItem = () => {
        MessageTemplate.bean.State = 2;
        //console.log(PaymentMethod.bean);
        editaItem();
        setModalC({ ...modalC, ['view']: false });
    }

    const editaItem = () => {
        //console.log(PaymentMethod.bean);
        MessageTemplate.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDMessageTemplate', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Código', property: 'CodeMessage', visible: true },
        // { title: 'Mensaje', property: 'MessageBody', visible: true },
        { title: 'Tipo Proceso', property: 'IDProcessType', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${MessageTemplate.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Plantilla mensajes">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={MessageTemplate.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectTypeProcees label='Tipo de Proceso' idSelector={MessageTemplate.bean.IDProcessType} onChange={(e: any) => { MessageTemplate.setBean({ ...MessageTemplate.bean, "IDProcessType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={MessageTemplate.bean.Name} onChange={MessageTemplate.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="CodeMessage" className="form-control" value={MessageTemplate.bean.CodeMessage} onChange={MessageTemplate.handleChange} />

                            </div>
                            <div className="col-md-12">
                                <label>Mensaje</label>
                                {/* <textarea name="MessageBody" className="form-control" value={MessageTemplate.bean.MessageBody} onChange={MessageTemplate.handleChange} /> */}
                                <MyEditor allowImage={true} val={MessageTemplate.bean.MessageBody} onChange={(e: any) => { MessageTemplate.setBean({ ...MessageTemplate.bean, 'MessageBody': e }) }} ></MyEditor>
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={eliminarItem}>
                        <strong>Eliminar item {MessageTemplate.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}